"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLocalCart = void 0;
const react_1 = require("react");
const providers_1 = require("../providers");
const reducers_1 = require("../reducers");
const utils_1 = require("../utils");
/**
 * Hook to manage the local cart state, don't use this hook to use cart, use {@link useCart} instead
 */
function useLocalCart() {
    const context = (0, react_1.useContext)(providers_1.CartContext);
    if (context === undefined) {
        throw new Error('useLocalCart must be used within a CartProvider');
    }
    const { dispatch } = context;
    const loadCart = () => __awaiter(this, void 0, void 0, function* () {
        const cartItems = (0, utils_1.getCartItemsFromLocalStorage)();
        dispatch((0, reducers_1.actionSetCartStrategy)('local'));
        if (!(cartItems === null || cartItems === void 0 ? void 0 : cartItems.length)) {
            dispatch((0, reducers_1.actionSetCartItems)([]));
        }
        else {
            dispatch((0, reducers_1.actionSetCartItems)(cartItems));
        }
        dispatch((0, reducers_1.actionSetCartIsLoaded)());
    });
    const createCart = () => __awaiter(this, void 0, void 0, function* () {
        dispatch((0, reducers_1.actionSetCartItems)([]));
        dispatch((0, reducers_1.actionSetCartStrategy)('local'));
        dispatch((0, reducers_1.actionSetCartIsLoaded)());
    });
    const addItem = (productItem, businessUnit) => __awaiter(this, void 0, void 0, function* () {
        dispatch((0, reducers_1.actionAddCartItem)((0, utils_1.mapCartItemFromProduct)(productItem, businessUnit)));
    });
    const removeItem = (item) => __awaiter(this, void 0, void 0, function* () {
        dispatch((0, reducers_1.actionRemoveCartItem)(item));
        dispatch((0, reducers_1.actionSetCartIsLoaded)());
    });
    const updateItemQuantity = (item) => __awaiter(this, void 0, void 0, function* () {
        dispatch((0, reducers_1.actionUpdateItemQuantity)(item));
        dispatch((0, reducers_1.actionSetCartIsLoaded)());
    });
    const clearCart = () => dispatch((0, reducers_1.actionClearCart)());
    const assignCustomerToCart = (customer) => __awaiter(this, void 0, void 0, function* () {
        throw new Error('Not implemented');
    });
    return {
        loadCart,
        createCart,
        addItem,
        removeItem,
        updateItemQuantity,
        assignCustomerToCart,
        clearCart,
    };
}
exports.useLocalCart = useLocalCart;
